import styled from "@emotion/styled";
export const StyledGridImage = styled.div`
  display: flex;

  .image {
    width: 100%;
  }
`;
